import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["messages", "input", "submit", "form"]
  static values = { url: String, csrf: String }

  connect() {
    this.history = []
    this.input = this.inputTarget
    this.input.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault()
        this.send(e)
      }
    })
  }

  prefill(event) {
    const text = event.currentTarget.dataset.text || ""
    this.input.value = text
    this.input.focus()
  }

  async send(event) {
    event.preventDefault()
    const message = this.input.value.trim()
    if (!message) return

    this.clearEmptyState()
    this.appendBubble("user", message)
    this.history.push({ role: "user", content: message })
    this.input.value = ""
    this.setBusy(true)

    try {
      const formData = new FormData()
      formData.append("authenticity_token", this.csrfValue)
      formData.append("message", message)
      this.history.slice(0, -1).forEach((m, idx) => {
        formData.append(`messages[${idx}][role]`, m.role)
        const c = typeof m.content === "string" ? m.content : JSON.stringify(m.content)
        formData.append(`messages[${idx}][content]`, c)
      })

      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: { Accept: "application/json", "X-CSRF-Token": this.csrfValue },
        body: formData,
      })

      if (!response.ok) {
        const err = await response.json().catch(() => ({}))
        this.appendBubble("error", err.error || `Error ${response.status}`)
        this.history.pop()
        return
      }

      const data = await response.json()
      this.appendBubble("assistant", data.assistant_text || "(sin respuesta)")
      this.history.push({ role: "assistant", content: data.assistant_text })

      if (data.mutated) {
        this.appendBubble("info", "Cambios aplicados. Recargando vista previa...")
        setTimeout(() => this.refreshPreview(), 600)
      }
    } catch (e) {
      this.appendBubble("error", e.message)
      this.history.pop()
    } finally {
      this.setBusy(false)
    }
  }

  refreshPreview() {
    const iframe = document.querySelector(".nl-preview-frame")
    if (iframe) {
      // Reload only the preview iframe so the chat history is preserved.
      iframe.src = iframe.src
    } else {
      window.location.reload()
    }
  }

  clearEmptyState() {
    const empty = this.messagesTarget.querySelector(".nl-chat-empty")
    if (empty) empty.remove()
  }

  setBusy(busy) {
    this.submitTarget.disabled = busy
    this.input.disabled = busy
    this.submitTarget.innerHTML = busy
      ? '<span class="spinner-border spinner-border-sm" role="status"></span>'
      : '<i class="fas fa-paper-plane"></i>'
  }

  appendBubble(role, text) {
    const row = document.createElement("div")
    row.className = `nl-row ${role}`
    const bubble = document.createElement("div")
    bubble.className = "nl-bubble"
    bubble.textContent = text
    row.appendChild(bubble)
    this.messagesTarget.appendChild(row)
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
  }
}
